// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__36Bmn","label":"Radio_label__1JoGF","checkMark":"Radio_checkMark__gIHJo","disabled":"Radio_disabled__3wh9D"};